<template>
  <ul class="py-4 text-base text-gray-600">
    <li v-for="item in listItems" :key="item.key">
      <i class="text-base text-green-400"
         :class="item.icon"></i>
      {{ item.title }}
    </li>
  </ul>
</template>

<script setup>

defineProps({
  listItems: Array
})
</script>
